export default __webpack_public_path__ + "static/media/xenon.428ff6cd.png";